/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useCallback } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {
  Button,
  Typography,
  Card,
  Table,
  CardContent,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TableFooter,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Link } from '@material-ui/icons';
import FilterCategoriesTree from './components/FilterNavigate';
import { SHeadTableCell } from '../../../../components/styledComponents/Tables';
import Preloader from '../../../../components/other/Preloader/Preloader';
import { Modal } from '../../../../components/other/Modals';
import TablePaginator from '../../../../components/tableComponents/TablePaginator/TablePaginator';
import { setLayoutFooter, setLayoutSubheader } from '../../../../utils/layout';
import { IAppState } from '../../../../store/rootDuck';
import { actions as usersActions } from '../../../../store/ducks/users.duck';
import useCrudSnackbar from '../../../../hooks/useCrudSnackbar';
import homeStyles from '../../../../constants/homeStyles';
import { useStyles } from './hooks/useStyles';
import { useFormatMessage, useShowErrors, useShowSuccesses } from '../../../../hooks';
import UsersEditPage from './UsersEditPage';
import UserEditDialog from './components/UserEditDialog';
import { generateDeepLink } from '../../../../utils/user';

const UsersPage: React.FC<TPropsFromRedux> = ({
  page,
  size,
  total,
  users,
  fetch,
  loading,
  clearDelUser,
  delUser,
  delUserSuccess,
  delUserLoading,
  delUserError,
  filter,
  clearAddUserId,
  clearEdit,
  editError,
  createLink,
  linkCode,
  linkSuccess,
  clearLink,
  clearAdd,
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const homeClasses = homeStyles();
  const fm = useFormatMessage();
  const [open, setOpen] = React.useState(false);
  const [openUser, setUserOpen] = React.useState(false);
  const [user, setUser] = React.useState<string>();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  
  console.log(user);
  
  useEffect(() => {
    const copyToClipboard = async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
      } catch (e) {
        console.log(e);
      }
    };

    if (linkCode) {
      try {
        const deepLink = generateDeepLink(linkCode);
        copyToClipboard(deepLink);
      } catch (e) {
        console.log(e);
      }
    }
  }, [linkCode]);

  useShowSuccesses([{ when: linkSuccess, msg: 'Link is successfully copied!'}]);
  

  useCrudSnackbar({
    success: delUserSuccess,
    error: delUserError,
    clear: clearDelUser,
    successMessage: fm('USER.SNACKBAR.DELETE.SUCCESS'),
    errorMessage: `${fm('ERROR')}: ${delUserSuccess}`,
    afterSuccessOrError: () => {
      setOpen(false);
      clearDelUser();
    },
    afterSuccess: () => {
      fetch({ page, size });
    },
  });

  useEffect(() => {
    clearAddUserId();
    fetch({ page, size });
    return () => {
      clearDelUser();
      clearLink()
      clearAdd()
      clearEdit()
    };
  }, [filter]);

   const handleDeclineClick = (event: React.MouseEvent<HTMLButtonElement>, item: any) => {
      clearEdit()
      clearAdd()
      setAnchorEl(event.currentTarget);
      setSelectedItem(item)
    };

  const handleEditUser = useCallback(async (id: string) => {
    if (id) {
      setUserOpen(true);
      setAnchorEl(null);
    }
  }, []);

  const onCreateLink = useCallback(async (id: string) => {
    if (id) {
      createLink(id)
    }
  }, []);

  const handleAddUser = useCallback(async () => {
    await setSelectedItem(null)
    await clearEdit()
    await clearAdd()
    setUserOpen(true)
  }, []);

  const onClose = () => {
    setOpen(false);
    setAnchorEl(null);
  }

  const handleDeleteUser = useCallback(() => {
      setOpen(true);
      setAnchorEl(null);
  }, []);
  

  useShowErrors([editError]);

  setLayoutSubheader({
    title: intl.formatMessage({ id: 'SUBMENU.USER_BY_ROLE.LIST' }),
    breadcrumb: [],
  });
  setLayoutFooter({ show: true });

  if (loading) return <Preloader />;

  return (
    <div style={{ maxWidth: 1440, width: '100%', margin: '0 auto' }}>
      <Row>
        <Col>
          <div className={classes.container}>
            <div className={classes.filterColTop}>
              <FilterCategoriesTree
                setSelectedCategoryId={setSelectedCategoryId}
                selectedCategoryId={selectedCategoryId}
              />
            </div>

            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginBottom: 16,
                }}
              >
                <Button
                  style={{ height: 52, width: 260, borderRadius: 12, textTransform: 'none' }}
                  color='primary'
                  variant='contained'
                  onClick={() => handleAddUser()}
                  className={classes.addBtn}
                >
                  Add new user
                </Button>
              </div>
              {loading ? (
                <div className={classes.preloaderContainer}>
                  <Preloader />
                </div>
              ) : !users ? (
                <Typography className={classes.empty} component='h5' variant='h5'>
                  {fm('COMMON.LIST.EMPTY')}
                </Typography>
              ) : (
                <Card className={classes.tableContainer}>
                  <CardContent className={homeClasses.tableContainer}>
                    <Table aria-label='simple table'>
                      <TableHead>
                        <TableRow>
                          <SHeadTableCell>{fm('USER.TABLE.FIO')}</SHeadTableCell>
                          <SHeadTableCell>{fm('USER.TABLE.EMAIL')}</SHeadTableCell>
                          <SHeadTableCell>CSB Client Id</SHeadTableCell>
                          <SHeadTableCell>{fm('BODY.TABLE.STATUS')}</SHeadTableCell>
                          <SHeadTableCell>Role</SHeadTableCell>
                          <SHeadTableCell align='right'>
                            {fm('USER.TABLE.ACTION')}
                          </SHeadTableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {users?.content?.map(item => (
                          <TableRow
                            style={{
                              backgroundColor: selectedItem?.id === item.id ? '#F5F6F9' : '',
                              borderRadius: 12
                            }}
                            key={item.id}>
                            <TableCell
                              onClick={() => setSelectedItem(item)}
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                                borderTopLeftRadius: selectedItem?.id === item.id ? '12px' : '',
                                borderBottomLeftRadius: selectedItem?.id === item.id ? '12px' : '',
                              }}
                            >
                              {`${item.lastName}  ${item.firstName}`}
                            </TableCell>

                            <TableCell
                              onClick={() => setSelectedItem(item)}
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                              }}
                            >
                              {item.email || '-'}
                            </TableCell>

                            <TableCell
                              onClick={() => setSelectedItem(item)}
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                              }}
                            >
                              {item.csbClientId}
                            </TableCell>

                            <TableCell
                              onClick={() => setSelectedItem(item)}
                              style={{
                                border: 'none',
                                fontWeight: 400,
                                fontSize: 16,
                                color: item.status === 'INACTIVE' ? '#DC1F1F' : '#1DA316',
                              }}
                            >
                              {item.status === 'INACTIVE' ? 'Deleted' : 'Active'}
                            </TableCell>

                            <TableCell
                              onClick={() => setSelectedItem(item)}
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                              }}
                            >
                              {item.role === 'ADMIN' ? 'Admin' : 'User'}
                            </TableCell>

                            <TableCell
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                                borderTopRightRadius: selectedItem?.id === item.id ? '12px' : '',
                                borderBottomRightRadius: selectedItem?.id === item.id ? '12px' : '',
                              }}
                              align='right'
                            >
                              <div className={classes.actions}>
                                {/* {item.role !== 'ADMIN' && ( */}
                                  <IconButton
                                    color='inherit'
                                    aria-label='previous'
                                    onClick={()=> onCreateLink(item.id)}
                                  >
                                    <Link />
                                  </IconButton>
                                {/* )} */}
                                
                                <IconButton
                                  color='inherit'
                                  aria-label='previous'
                                  style={{borderRadius: 12, width: 113, height: 43,}}
                                  onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                                    handleDeclineClick(e, item)
                                  }
                                >
                                  Edit
                                </IconButton>
                              </div>
                            </TableCell>
                            <UserEditDialog
                              anchorEl={anchorEl}
                              onDelete={() => handleDeleteUser()}
                              onClose={() => onClose()}
                              onConfirm={() => handleEditUser(item.id)}
                            />
                          </TableRow>
                        ))}
                      </TableBody>

                      <TableFooter>
                        <TableRow style={{ border: 'none' }}>
                          <TablePaginator
                            page={page}
                            realPerPage={20}
                            perPage={size}
                            total={total}
                            fetchRows={(data: any) => fetch({ ...data, filter })}
                            label={fm('USER.TABLE.PER_PAGE')}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Modal
        open={open}
        deleteContent
        onClose={delUserLoading ? () => {} : () => {
          setOpen(false);
        }}
        loading={delUserLoading}
        content={delUserLoading ? undefined : fm('USER.DELETE.TEXT')}
        actions={
          delUserLoading
            ? undefined
            : [
                {
                  title: fm('COMMON.BUTTON.CANCEL'),
                  onClick: () => setOpen(false),
                },
                {
                  title: fm('COMMON.BUTTON.DELETE'),
                  onClick: () => delUser(selectedItem.id),
                },
              ]
        }
      />

      <Modal
        open={openUser}
        onClose={
          delUserLoading
            ? () => {}
            : () => {
                setUserOpen(false);
              }
        }
        title={selectedItem ? 'Edit user' : 'Add new user'}
        content={
          <UsersEditPage
            setUserOpen={setUserOpen}
            setUser={setUser}
            id={selectedItem && selectedItem.id || ''}
            type='new'
          />
        }
      />
    </div>
  );
};

const connector = connect(
  (state: IAppState) => ({
    page: state.users.page,
    size: state.users.size,
    total: state.users.total,
    users: state.users.users,
    loading: state.users.loading,
    delUserSuccess: state.users.delUserSuccess,
    delUserLoading: state.users.delUserLoading,
    delUserError: state.users.delUserError,
    filter: state.users.filter,
    editSuccess: state.users.editSuccess,
    editError: state.users.editError,
    linkCode: state.users.linkCode,
    linkSuccess: state.users.linkSuccess,
  }),
  {
    fetch: usersActions.fetchRequest,
    clearDelUser: usersActions.clearDelUser,
    delUser: usersActions.delUserRequest,
    setUsersList: usersActions.setUsers,
    setFilter: usersActions.setFilter,
    clearAddUserId: usersActions.clearAddUserId,
    clearEdit: usersActions.clearEdit,
    createLink: usersActions.createLinkRequest,
    clearLink: usersActions.clearLink,
    clearAdd: usersActions.clearAdd,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(UsersPage);
